<template>
    <div class="layout-wrapper landing">

        <Header/>

        <div class="bg-overlay bg-overlay-pattern"></div>

        <section
            class="position-relative"
            id="hero"
        >

            <router-link to="/vagas">
                <Loading v-if="!loaded"/>
                <img
                    v-if="data && data.banner && loaded"
                    :src="`${env.url}uploads/landing-pages/${data.banner}`"
                    id="banner_lp"
                    class="img-fluid"
                    alt="banner_lp"
                >
                <img
                    v-else
                    src="@/assets/images/capa.jpeg"
                    id="banner_lp"
                    class="img-fluid"
                    alt="banner_lp"
                >
            </router-link>
        </section>

        <section
            class="section bg-light"
            id="marketplace"
        >
            <BContainer>
                <BRow class="justify-content-center">
                    <BCol
                        lg="8"
                        class="d-flex justify-content-between"
                    >
                        <div class="mb-2">
                            <div class="p-2 bg-white d-inline-block">
                                <h2 class="fw-semibold mb-0">Sobre</h2>
                            </div>
                            <p class="text-justify mt-3">
                                Seja bem-vindo(a) à Plataforma de Vagas do Instituto Libertas.
                            </p>

                            <p class="text-justify">
                                O Libertas é a Fundação Partidária do Partido NOVO. Como uma instituição comprometida
                                com uma política transformadora, precisamos dar o exemplo começando dentro de casa.
                            </p>

                            <p class="text-justify">
                                Nesse sentido, este site foi desenvolvido para ofertar oportunidades das mais diversas
                                no Partido NOVO, em busca de bons profissionais, comprometidos com um ideal de Brasil a
                                ser construído.
                            </p>

                            <p class="text-justify">
                                Por aqui, você pode encontrar:
                            </p>

                            <ul>
                                <li>Banco de Talentos do Partido NOVO</li>
                                <li>Vagas em Gabinetes Legislativos</li>
                                <li>Vagas em Equipe de Secretariado</li>
                                <li>Vagas na estrutura do Partido NOVO</li>
                                <li>Vagas no Instituto Libertas</li>
                            </ul>

                        </div>
                        <div class="mb-5 d-flex flex-column justify-content-center">
                            <img
                                class="img-fluid ms-3 d-none d-sm-block mx-auto"
                                src="@/assets/images/icon.png"
                                alt="logo_libertas"
                                style="width: auto"
                            >
                        </div>
                    </BCol>

                    <BCol
                        lg="8"
                        class="text-center mt-4"
                        style="margin-top: 30px"
                    >
                        <router-link to="/vagas">
                            <BButton
                                variant="primary"
                                size="lg"
                            >Quero Participar
                            </BButton>
                        </router-link>
                    </BCol>

                </BRow>
            </BContainer>
        </section>

        <section
            class="section bg-secondary"
            id="categories"
        >
            <BContainer fluid>

                <BRow class="justify-content-center">
                    <BCol
                        lg="4"
                        md="5"
                        sm="8"
                        class="text-center mb-5"
                    >

                        <img
                            @click="setSector(3)"
                            src="@/assets/images/boxe-3.png"
                            alt="boxe-3"
                            class="img-fluid box pointer"
                        >
                    </BCol>

                    <BCol
                        lg="4"
                        md="5"
                        sm="8"
                        class="text-center mb-5"
                    >

                        <img
                            @click="setSector(1)"
                            src="@/assets/images/boxe-1.png"
                            alt="boxe-1"
                            class="img-fluid box pointer"
                        >
                    </BCol>

                    <BCol
                        lg="4"
                        md="5"
                        sm="8"
                        class="text-center"
                    >

                        <img
                            @click="setSector(2)"
                            src="@/assets/images/boxe-2.png"
                            alt="boxe-2"
                            class="img-fluid box pointer"
                        >

                    </BCol>


                </BRow>

            </BContainer>
        </section>

        <section
            class="section py-5"
            id="steps"
        >
            <BContainer>
                <img
                    class="img-fluid"
                    src="@/assets/images/etapas.png"
                    alt="etapas_img"
                >

                <BRow>
                    <BCol class="text-center mt-5">
                        <a
                            href="https://drive.google.com/file/d/1JAIbic1RYY_qpR4Z2HtocVbEwtl7HQoy/view?usp=sharing"
                            target="_blank"
                            class="text-white"
                        >
                            <BButton
                                variant="secondary"
                                size="lg"
                            >Acessar guia do participante
                            </BButton>
                        </a>
                    </BCol>
                </BRow>
            </BContainer>
        </section>

        <section
            class="section bg-light py-5"
            id="testimonials"
        >
            <BContainer>
                <BRow>
                    <BCol
                        xxl="12"
                        class="text-center mb-4"
                    >
                        <div class="p-2 bg-white d-inline-block">
                            <h2 class="fw-semibold mb-0">Depoimentos</h2>
                        </div>
                    </BCol>

                    <BCol md="4">
                        <img
                            class="img-fluid"
                            src="@/assets/images/depoimento-01.png"
                            alt="depoimento-01"
                        >
                    </BCol>

                    <BCol md="4">
                        <img
                            class="img-fluid"
                            src="@/assets/images/depoimento-02.png"
                            alt="depoimento-02"
                        >
                    </BCol>

                    <BCol md="4">
                        <img
                            class="img-fluid"
                            src="@/assets/images/depoimento-03.png"
                            alt="depoimento-03"
                        >
                    </BCol>

                </BRow>
            </BContainer>
        </section>

        <Footer/>
    </div>
</template>

<script setup>
import Footer from './footer.vue';
import Header from './header.vue';
import Loading from "@/components/base/loading.vue";
import {useRoute} from "vue-router";
import {onMounted, ref} from "vue";
import http from '@/http';
import env from '@/env'
import router from "@/router";

const route = useRoute();

const data = ref(null);
const loaded = ref(false);

function getData(city) {
    http.get('landing-pages/' + city)
        .then(response => {
            if (response.data.message) {
                data.value = response.data.message;
                const obj = {
                    state: response.data.message.state,
                    city: response.data.message.city,
                    title: '',
                    sector: ''
                }
                sessionStorage.setItem('vacancies', JSON.stringify(obj));

                const urlImg = `${env.url}uploads/landing-pages/${data.value.banner}`;

                setMeta(urlImg);
            }
        })
        .finally(() => {
            setTimeout(() => {
                loaded.value = true;
            }, 200)
        })
}

function setSector(value) {
    let session = JSON.parse(sessionStorage.getItem('vacancies'));

    session.sector = value;

    sessionStorage.setItem('vacancies', JSON.stringify(session));

    router.push('/vagas')
}

function setMeta(urlImg) {
    // Verifica se a tag <meta> já existe
    let metaTag = document.querySelector('meta[property="og:image"]');

    if (!metaTag) {
        // Se não existir, cria uma nova tag <meta>
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', 'og:image');
        document.head.appendChild(metaTag);
    }

    // Define ou atualiza o conteúdo da tag <meta>
    metaTag.setAttribute('content', urlImg);
}

onMounted(() => {
    const city = route.params.city;
    if (city) {
        sessionStorage.setItem('city', city);
        getData(city);
    } else {
        const data = {
            state: '',
            city: '',
            title: '',
            sector: ''
        }
        sessionStorage.removeItem('city');
        sessionStorage.setItem('vacancies', JSON.stringify(data));
        loaded.value = true;

        const urlImg = `/images/capa.jpeg`;

        setMeta(urlImg);
    }

    let backtoTop = document.getElementById("back-to-top");

    if (backtoTop) {
        backtoTop = document.getElementById("back-to-top");
        window.onscroll = function () {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                backtoTop.style.display = "block";
            } else {
                backtoTop.style.display = "none";
            }
        };
    }
})


</script>
